import { SHOPPING_CATEGORIES, type ShoppingCategory } from './types'

export { SHOPPING_CATEGORIES }

export function formatQuantity(quantity: string, unit: string) {
  const qty = quantity.trim()
  const measure = unit.trim()
  if (!qty && !measure) return ''
  return [qty, measure].filter(Boolean).join(' ')
}

export function formatRelativeTime(iso: string) {
  const then = new Date(iso).getTime()
  const now = Date.now()
  const diff = Math.max(0, now - then)
  const minutes = Math.floor(diff / 60000)
  if (minutes < 1) return 'just now'
  if (minutes < 60) return `${minutes} min ago`
  const hours = Math.floor(minutes / 60)
  if (hours < 24) return `${hours} hr${hours === 1 ? '' : 's'} ago`
  const days = Math.floor(hours / 24)
  if (days < 7) return `${days} day${days === 1 ? '' : 's'} ago`
  return new Date(iso).toLocaleDateString()
}

export function itemCountLabel(count: number) {
  return `${count} item${count === 1 ? '' : 's'}`
}

export function categoryCount(items: { category: ShoppingCategory }[]) {
  return SHOPPING_CATEGORIES.filter((category) =>
    items.some((item) => item.category === category)
  ).length
}
